if(typeof __WEBPACK_EXTERNAL_MODULE_38__ === 'undefined') {var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_38__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"interact","commonjs":"interact.js","commonjs2":"interact.js","amd":"interact"}
 ** module id = 38
 ** module chunks = 0
 **/